// extracted by mini-css-extract-plugin
export default {"wrap":"nBlU5YR69t8021O17fFg","radius":"WWTmihKQ5VYqwxURmUas","fullWidth":"JvlHUHZ3ppZKRwflF3ue","img":"P1Cg56QR2tVkjMPf3Nqw","loaderWrap":"yAgBlh8_y2sy8AFWG_tY"};